










import Vue from 'vue'
import style from './style.module.scss'

import tableContainer from '@/components/common/tables/table-container.vue'
import simpleTable from '@/components/common/tables/simple-table/simple-table.vue'
import buttonRed from '@/components/common/click/button/button-red.vue'

import percentCell from './cells/percent-cell.vue'
import minVolumeCell from './cells/min-volume-cell.vue'
import maxVolumeCell from './cells/max-volume-cell.vue'

import { CellSettings, TableCell, CellHeader } from '@/types/table'
import { Discount } from '@/types/price-settings'

import { mapGetters } from 'vuex'
import { CategoryType } from '@/types/product/CategoryType'


const cellSettings: CellSettings<Discount> = {
    MinVolume: { name: 'Минимальный объем' },
    MaxVolume: { name: 'Максимальный объем' },
    Percent: { name: 'Скидка' }
}

export default Vue.extend({
    name: 'edit-discount-table',
    components: {
        tableContainer,
        simpleTable,
        buttonRed
    },
    props: {
        discountList: {} as () => Discount[],
        priceSettingId: [String, Number],
        typeCode: String
    },
    data() {
        return {
            style: style
        }
    },
    mounted() {
        this.checkRows()
    },
    methods: {
        ...mapGetters(["selectedCategoryType"]),
        checkRows() {
            if(!this.discountList.length)  {
                this.addRow();
                return;
            }
            const lastRow = this.discountList[this.discountList.length - 1];
            if(lastRow.MaxVolume || lastRow.MinVolume || lastRow.Percent) {
                this.addRow();
            }
        },
        addRow() {

            const Id = 0;
                            
            const discount: Discount = {
                Id: this.discountList.length ? this.discountList[this.discountList.length - 1].Id + 1 : Id,
                ParentId: this.priceSettingId,
                MaxVolume: null,
                MinVolume: null,
                Percent: null,
                Cells: null
            }
            this.discountList.push(discount);
        },
        fillCells(): TableCell[] {
            return [
                {
                    Name: cellSettings.MinVolume?.name,
                    Component: minVolumeCell
                },
                {
                    Name: cellSettings.MaxVolume?.name,
                    Component: maxVolumeCell
                },
                {
                    Name: cellSettings.Percent?.name,
                    Component: percentCell
                }
            ]
        }
    },
    computed: {
        rows: {
            get(): Discount[] {
                return this.discountList.map((row) => {
                    row.Cells = this.fillCells();
                    row.ParentId = this.priceSettingId;
                    return row;
                })
            }
        },
        headers(): CellHeader[] {

            const headers = Object.values(cellSettings);
            const categoryType = this.$store.getters.selectedCategoryType;
            const unitName = this.$store.getters.getUnitName.unitName;

            return headers.map((header) => {
                if(header) {
                    if(unitName && header.name.indexOf('объем') > -1 && categoryType  === CategoryType.Product){
                    header.unitName = unitName;
                    } else {
                        header.unitName = '';
                    }
                    return header
                } else {
                    return {
                        name: 'Пустой заголовок'
                    }
                }
            });                      
        }
    }
})
